import type { DepartmentRepository } from "../../../domain/repositories/company/department-repository";
import { departmentApiService } from "../../api/company/department-api-service";
import type { Department } from "../../../domain/types/department";
import type { UserInfoResponse } from "../../../shared/types/api";

export class DepartmentRepositoryImpl implements DepartmentRepository {
  async getDepartments(companyId: number): Promise<Department[]> {
    const response = await departmentApiService.getDepartments(companyId);
    if (response.data) {
      return response.data;
    }
    throw new Error(response.errorMsg || "부서 목록을 불러오지 못했습니다.");
  }

  async createDepartment(companyId: number, name: string): Promise<Department> {
    const response = await departmentApiService.createDepartment(companyId, name);
    if (response.data) {
      return response.data;
    }
    throw new Error(response.errorMsg || "부서 생성에 실패했습니다.");
  }

  async updateDepartment(
    companyId: number,
    departmentId: number,
    name: string,
  ): Promise<Department> {
    const response = await departmentApiService.updateDepartment(companyId, departmentId, name);
    if (response.data) {
      return response.data;
    }
    throw new Error(response.errorMsg || "부서 수정에 실패했습니다.");
  }

  async reorderDepartments(
    companyId: number,
    departmentIds: number[],
  ): Promise<Department[]> {
    const response = await departmentApiService.reorderDepartments(companyId, departmentIds);
    if (response.data) {
      return response.data;
    }
    throw new Error(response.errorMsg || "부서 순서 변경에 실패했습니다.");
  }

  async deleteDepartment(companyId: number, departmentId: number): Promise<void> {
    await departmentApiService.deleteDepartment(companyId, departmentId);
  }

  async assignMembers(
    companyId: number,
    departmentId: number,
    userIds: number[],
  ): Promise<UserInfoResponse[]> {
    const response = await departmentApiService.assignMembers(companyId, departmentId, userIds);
    if (response.data) {
      return response.data;
    }
    throw new Error(response.errorMsg || "부서 회원 배정에 실패했습니다.");
  }

  async removeMember(
    companyId: number,
    departmentId: number,
    userId: number,
  ): Promise<void> {
    await departmentApiService.removeMember(companyId, departmentId, userId);
  }
}
